var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack240({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.53,11.25V8.8a3.21,3.21,0,0,1-1.69-1,2.52,2.52,0,0,1-.53-1.61,2.32,2.32,0,0,1,.6-1.62,2.52,2.52,0,0,1,1.62-.75V3.24h.85v.58a2.55,2.55,0,0,1,1.48.64,2.4,2.4,0,0,1,.7,1.4l-1.48.19a1.17,1.17,0,0,0-.7-.93V7.41a3.75,3.75,0,0,1,1.91,1A2.36,2.36,0,0,1,10.8,10a2.6,2.6,0,0,1-.64,1.79,2.84,2.84,0,0,1-1.78.89v1.09H7.53V12.66a2.77,2.77,0,0,1-1.65-.76,3.14,3.14,0,0,1-.81-1.79L6.6,10a2.12,2.12,0,0,0,.35.81A1.75,1.75,0,0,0,7.53,11.25Zm0-6.15A1.07,1.07,0,0,0,7,5.5a1,1,0,0,0-.21.62A.93.93,0,0,0,7,6.69a1.25,1.25,0,0,0,.57.44Zm.85,6.23a1.18,1.18,0,0,0,.71-.4,1.14,1.14,0,0,0,.28-.77,1.07,1.07,0,0,0-.23-.68,1.5,1.5,0,0,0-.76-.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack240);
export default __webpack_public_path__ + "static/media/Symbolpack_2_40.cd7549c586d25884f7575d91b83a0637.svg";
export { ForwardRef as ReactComponent };